import { z } from "zod";

/**
 * Client env is public by construction — Vite inlines VITE_* at build time.
 * Validate it anyway so a typo fails the boot, not a fetch three screens in.
 *
 * VITE_API_URL is empty by default, meaning "same origin": Vite proxies /api in
 * dev and preview, so the session cookie is first-party everywhere.
 */
export const clientEnv = z
  .object({
    VITE_API_URL: z.string().default(""),
    VITE_SENTRY_DSN: z.string().optional(),
  })
  .parse(import.meta.env);
